// src/atoms/mapAtom.ts
import { atom } from 'jotai';
import Map from 'ol/Map';

export const mapInstanceAtom = atom<Map | null>(null);
export const mapControlsAtom = atom<any>(null);